module.exports = __webpack_public_path__ + "media/img/slider_bcg-f174fa7a.png";